<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer010">
<p class="_heads_1toc" id="_idParaDest-4">Contents<a id="_idTextAnchor000"></a></p>
<p class="_toc_toc5"><a href="#/Fwd#_idTextAnchor001">Foreword</a> by Don Milo Duquette</p>
<p class="_toc_toc1"><a href="#/Thelema#_idTextAnchor002">Introduction</a></p>
<p class="_toc_toc1"><a href="#/Thelema1#_idTextAnchor004">Onion Peelings</a></p>
<p class="_toc_toc2">1. <a href="#/Thelema2#_idTextAnchor006">Man, Myth, and Legend</a> </p>
<p class="_toc_toc2">2. <a href="#/Thelema3#_idTextAnchor007">Philosophy</a> </p>
<p class="_toc_toc2">3. <a href="#/Thelema4#_idTextAnchor008">Practices and Observations</a> </p>
<p class="_toc_toc2">4. <a href="#/Thelema5#_idTextAnchor011">Modern Thelema</a> </p>
<p class="_toc_toc5"><a href="#/Thelema6#_idTextAnchor012">Bibliography</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7b763edc